// extracted by mini-css-extract-plugin
export default {"eventCardDarkList":"EventCardDarkList_eventCardDarkList__++apC","eventCardDark":"EventCardDarkList_eventCardDark__+QCWI"};